<template>
    <b-modal ref="modal" centered :title="(questionData.name != null) ? questionData.name : ''" @close="close()" hide-header no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{(questionData.name != null) ? questionData.name : ''}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
            <div role="group" class="b-form-group form-group">
                <template v-for="question in questionData.questions">
                    <div class="col-sm-12" :key="question.questionsId">
                        <b-form-fieldset v-bind:label="setLabel(question)">
                            <inputvalidation :formerror="formError" :name="`answer_${question.questionsId}`">
                                <b-form-input v-if="question.questionType === 'textfield'" type="text" v-model="formAnswers[question.questionsId].answer"></b-form-input>
                                <b-form-input v-if="question.questionType === 'number'" :max="question.comboAnswers[0].max" :min="question.comboAnswers[1].min" type="number" v-model="formAnswers[question.questionsId].answer"></b-form-input>
                                <b-form-textarea v-if="question.questionType === 'textarea'" type="text" v-model="formAnswers[question.questionsId].answer"></b-form-textarea>
                                <div class="custom-file" v-if="question.questionType === 'camera'">
                                    <input type="file" class="custom-file-input" @change="uploadFile($event.target.files, question.questionsId)">
                                    <label class="custom-file-label" for="customFile">Choose file</label>
                                </div>
                                <b-form-select
                                    v-if="question.questionType === 'singleCombo'"
                                    :options="question.comboAnswers"
                                    @change="checkWhatField($event, question)"
                                    v-model="formAnswers[question.questionsId].answer"
                                    value-field="id"
                                    text-field="text">
                                </b-form-select>
                                <b-form-select
                                    v-if="question.questionType === 'multyCombo'"
                                    :options="question.comboAnswers"
                                    v-model="formAnswers[question.questionsId].answer"
                                    multiple
                                    value-field="id"
                                    text-field="text">
                                </b-form-select>
                                <b-form-checkbox
                                    v-if="question.questionType === 'checkbox'"
                                    v-model="formAnswers[question.questionsId].answer"
                                    :value="1"
                                    :unchecked-value="0"
                                    >
                                </b-form-checkbox>
                                <datetimepicker
                                  v-if="question.questionType === 'dateTime'"
                                  type="datetime"
                                  v-model="formAnswers[question.questionsId].answer"
                                  format="DD.MM.YYYY. HH:mm"
                                  display-format="DD.MM.YYYY. HH:mm"
                                  :showSeconds="false"
                                  :isUTC="false"
                                  :simple="true"
                                  :translate-method="trans">
                                </datetimepicker>
                                <datetimepicker
                                  v-if="question.questionType === 'date'"
                                  type="date"
                                  v-model="formAnswers[question.questionsId].answer"
                                  format="DD.MM.YYYY."
                                  display-format="DD.MM.YYYY."
                                  :showSeconds="false"
                                  :isUTC="true"
                                  :simple="true"
                                  :translate-method="trans">
                                </datetimepicker>
                                <datetimepicker
                                  v-if="question.questionType === 'time'"
                                  type="time"
                                  v-model="formAnswers[question.questionsId].answer"
                                  format="HH:mm"
                                  display-format="HH:mm"
                                  :showSeconds="false"
                                  :isUTC="false"
                                  :simple="true"
                                  :translate-method="trans">
                                </datetimepicker>
                                <div v-if="question.questionType === 'signature'">
                                  <VueSignaturePad width="500px" height="500px" ref="signaturePad" />
                                  <button @click="undo">Undo</button>
                                </div>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-12" :key="`${question.questionsId}_sec`"
                        v-if="singleComboWithOtherQuestionId[question.questionsId] === question.questionsId">
                        <inputvalidation :formerror="formError" :name="`answer_${question.questionsId}`">
                            <b-form-input
                                type="text"
                                v-model="singleComboWithOtherValue[question.questionsId]">
                            </b-form-input>
                        </inputvalidation>
                    </div>
                </template>
            </div>

            <div class="text-center mt-lg">
                <template v-for="button in questionData.action">
                    <b-btn :key="button.stepButtonId"
                    class="mr-2 btn-bis btn-cancel" @click="(button.isFinal != 0) ? submitData(button) : getNextStep(button)">
                    {{$t(button.label.toUpperCase())}}</b-btn>
                </template>
            </div>

        </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import Api from '@/api/job/JobAnswer.js';
import JobApi from '@/api/job/Job.js';
import localTranslate from '../../helpers/local_trans';

export default
{
    name: 'AnswerForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            singleComboWithOtherQuestionId: {},
            singleComboWithOtherValue: {},
            formStructure: {},
            orderOfSteps: [],
            questionData: {},
            formAnswers: {},
            answersArray: [],
            answersForSubmitin: {},
            formError: {},
            formData: null,
            fileUpload: null,
        };
    },
    methods:
    {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
        undo() {
          this.$refs.signaturePad[0].undoSignature();
        },
        uploadFile(item, questionsId)
        {
            const me = this;

            const file = item[0];
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                if ((encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                }
                me.formAnswers[questionsId].answer = encoded;
            };
        },
        async signIfAvailable()
        {
            const me = this;

            for (const question of me.questionData.questions)
            {
                if (question.questionType === 'signature')
                {
                    const { isEmpty, data } = this.$refs.signaturePad[0].saveSignature();

                    if (isEmpty)
                    {
                        me.formAnswers[question.questionsId].answer = 'NO_SIGNATURE';
                        return;
                    }
                    const signatureBase64 = data;
                    me.formAnswers[question.questionsId].answer = signatureBase64;
                }
            }

            return;
        },
        checkWhatField(event, question)
        {
            const me = this;
            if (event === 'other')
            {
                me.$set(me.singleComboWithOtherQuestionId, question.questionsId, question.questionsId);
            }

            if (event !== 'other'
                && me.singleComboWithOtherQuestionId[question.questionsId] != null
                && me.singleComboWithOtherQuestionId[question.questionsId] == question.questionsId)
            {
                me.singleComboWithOtherValue[question.questionsId] = '';
                me.$set(me.singleComboWithOtherQuestionId, question.questionsId, null);
                delete (me.singleComboWithOtherQuestionId[question.questionsId]);
            }
        },
        setLabel(question)
        {
            const me = this;
            let msg = question.label;

            if (!question.isRequired)
            {
                msg += ` - ${me.$t('OPTIONAL')}`;
            }

            return msg;
        },
        getType(type)
        {
            let returnType = null;
            switch (type) {
                case value:

                    break;

                default:
                    break;
            }

            return returnType;
        },
        async getNextStep(item)
        {
            const me = this;
            me.formError = {};
            let nextStep = null;
            try
            {
                if (item.nextStepId != null)
                {
                    const place = me.orderOfSteps.indexOf(item.nextStepId);
                    nextStep = me.orderOfSteps[place];
                }
                else
                {
                    const place = me.orderOfSteps.indexOf(item.stepId);
                    nextStep = me.orderOfSteps[place+1];
                }

                const nextData = me.formStructure[nextStep];

                let shipCheck = false;
                if (item.skipCheck == 1)
                {
                    shipCheck = true;
                }

                if (!shipCheck)
                {
                    await me.validateAnwers();
                }

                for (const key in me.formAnswers)
                {
                    if (me.formAnswers[key] != null)
                    {
                        if (me.singleComboWithOtherValue[key] != null && me.singleComboWithOtherValue[key] !== '')
                        {
                            me.formAnswers[key].answer = me.singleComboWithOtherValue[key];
                        }

                        if (me.formAnswers[key].questionType === "signature")
                        {
                          const { isEmpty, data } = this.$refs.signaturePad[0].saveSignature();

                          let encoded = data.replace(/^data:(.*,)?/, '');
                          if ((encoded.length % 4) > 0) {
                            encoded += '='.repeat(4 - (encoded.length % 4));
                          }

                          me.formAnswers[key].answer = encoded;
                        }

                        if (me.formAnswers[key].isRequired == 0 && (me.formAnswers[key].answer === null || me.formAnswers[key].answer === ''))
                        {
                            continue;
                        }
                        me.answersArray.push(me.formAnswers[key]);
                    }
                }

                // me.answersForSubmitin = { ...me.answersForSubmitin, ...me.formAnswers };
                me.questionData = {};

                if (me.orderOfSteps.indexOf(nextData.stepId) !== 0
                    && nextData.action.find( item => item.stepButtonId === 99999) == null)
                {
                    nextData.action.push({
                        stepButtonId: 99999,
                        label: me.$t('BACK'),
                        nextStepId: item.stepId,
                        stepId: nextData.stepId,
                        isFinal: 0,
                        skipCheck: 1,
                    });
                }
                me.questionData = nextData;
            }
            catch (error)
            {
                console.log(error);
                me.formError = error;
            }
        },
        async submitData(item)
        {
            const me = this;
            me.formError = {};
            try
            {
                await me.signIfAvailable();

                await me.validateAnwers();

                for (const key in me.formAnswers)
                {
                    if (me.formAnswers[key] != null)
                    {
                        if (me.formAnswers[key].questionType === "signature")
                        {
                            const { isEmpty, data } = this.$refs.signaturePad[0].saveSignature();

                            let encoded = data.replace(/^data:(.*,)?/, '');
                            if ((encoded.length % 4) > 0) {
                              encoded += '='.repeat(4 - (encoded.length % 4));
                            }

                            me.formAnswers[key].answer = encoded;
                        }

                        if (me.formAnswers[key].isRequired == 0 && (me.formAnswers[key].answer == null || me.formAnswers[key].answer == ''))
                        {
                            continue;
                        }
                        me.answersArray.push(me.formAnswers[key]);
                    }
                }

                // me.answersForSubmitin = { ...me.answersForSubmitin, ...me.formAnswers };
                me.answersForSubmitin.answers = me.answersArray;
                me.answersForSubmitin.status = item.status;
                await me.saveData();
            }
            catch (error)
            {
                console.log(error);
                me.formError = error;
            }
        },
        async saveData()
        {
            const me = this;
            try
            {
                const data = await Api.save(me.answersForSubmitin, 'postOfImage');
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async getFormStructure(jobId)
        {
            const me = this;
            try
            {
                const data = await JobApi.getFormStructure({ jobId: jobId });
                if (data.error && data.error === true)
                {
                    throw (data);
                }

                me.formStructure = data.data;
                me.orderOfSteps = data.orderOfSteps;
                me.questionData = me.formStructure[me.orderOfSteps[0]];
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async validateAnwers()
        {
            const me = this;
            const error = {
                error: true,
                code: 'field_errors',
                notice: 'FIELD_ERRORS',
                errors: [],
            };
            for (const key in me.formAnswers)
            {
                if (me.formAnswers[key] != null)
                {
                    const value = me.formAnswers[key];
                    if ((value.answer === null || value.answer === '') && value.isRequired === 1)
                    {
                        error.errors.push({
                            error: true,
                            code: 'please_insert_answer',
                            notice: 'PLEASEINSERTANSWER',
                            params:
                            {
                                field: `answer_${value.questionId}`
                            }
                        });
                    }

                    if (value.questionType === 'number')
                    {
                        if (parseInt(value.answer, 10) < parseInt(value.comboAnswers[1].min, 10))
                        {
                            error.errors.push({
                                error: true,
                                code: 'please_insert_number_bigger_than_min',
                                notice: 'PLEASEINSERTNUMBERBIGGERTHANMIN',
                                params:
                                {
                                    field: `answer_${value.questionId}`,
                                    value: value.comboAnswers[1].min,
                                }
                            });
                        }

                        if (parseInt(value.answer, 10) > parseInt(value.comboAnswers[0].max, 10))
                        {
                            error.errors.push({
                                error: true,
                                code: 'please_insert_number_lower_than_max',
                                notice: 'PLEASEINSERTNUMBERLOWERTHANMAX',
                                params:
                                {
                                    field: `answer_${value.questionId}`,
                                    value: value.comboAnswers[0].max,
                                }
                            });
                        }
                    }

                    if (me.singleComboWithOtherQuestionId[key] != null
                        && me.singleComboWithOtherQuestionId[key] == key
                        && (me.singleComboWithOtherValue[key] == null || me.singleComboWithOtherValue[key] === ''))
                    {
                        error.errors.push({
                            error: true,
                            code: 'please_insert_number_lower_than_max',
                            notice: 'PLEASEINSERTVALIDREASON',
                            params:
                            {
                                field: `answer_${value.questionId}`
                            }
                        });
                    }
                }
            }

            if (error.errors.length > 0)
            {
                throw (error);
            }
        },
        setupAnswersForm(item)
        {
            const me = this;
            me.formAnswers = {};
            const questionTypeForNull = ['dateTime', 'date', 'time']
            for (const question of item.questions)
            {
                me.formAnswers[question.questionsId] = {};
                me.formAnswers[question.questionsId].flowId = item.flowId;
                me.formAnswers[question.questionsId].stepId = item.stepId;
                me.formAnswers[question.questionsId].questionId = question.questionsId;
                me.formAnswers[question.questionsId].isRequired = question.isRequired;
                me.formAnswers[question.questionsId].questionType = question.questionType;
                me.formAnswers[question.questionsId].comboAnswers = question.comboAnswers;
                me.formAnswers[question.questionsId].jobId = me.formData.jobId;

                if (question.questionType === 'checkbox')
                {
                    me.formAnswers[question.questionsId].answer = 0;
                }
                else
                {
                    me.formAnswers[question.questionsId].answer = (questionTypeForNull.indexOf(question.questionType) !== -1) ? null : "";
                }
            }
        },
        close()
        {
            const me = this;
            me.answersForSubmitin = {};
            me.formStructure = {};
            me.orderOfSteps = [];
            me.questionData = {};
            me.answersArray = [];
            me.formAnswers = {};
            me.formError = {};
            me.formData = null;
            me.singleComboWithOtherQuestionId = {};
            me.singleComboWithOtherValue = {};
            me.$emit('close');
        },
    },
    watch:
    {
        questionData(val)
        {
            const me = this;
            if (Object.keys(val).length > 0)
            {
                me.setupAnswersForm(val);
            }
        },
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                me.answersForSubmitin.flowId = val.flowId;
                me.answersForSubmitin.jobId = val.jobId;
                await me.getFormStructure(val.jobId);
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
